import { Controller } from "@hotwired/stimulus"

// Stimulus controller for admin filter forms that load results into a Turbo Frame.
//
// Usage in HAML (controller on wrapper div containing form + turbo-frame):
//   %div{ data: { controller: 'admin-filter', admin_filter_frame_value: 'resultados' } }
//     = form_with(..., local: true, data: { turbo_frame: 'resultados',
//         action: 'turbo:submit-start->admin-filter#showSpinner' }) do |f|
//     = turbo_frame_tag 'resultados', data: { action: 'turbo:frame-load->admin-filter#hideSpinner' }
//
export default class extends Controller {
  static values = { frame: { type: String, default: 'resultados' }, autosubmit: { type: Boolean, default: true } }

  connect () {
    if (this.autosubmitValue) {
      const form = this.element.querySelector('form#filtro') || this.element.querySelector('form')
      if (form) form.requestSubmit()
    }
  }

  showSpinner () {
    const frame = document.getElementById(this.frameValue)
    if (frame) frame.classList.add('rnk-Locked')
  }

  hideSpinner () {
    const frame = document.getElementById(this.frameValue)
    if (frame) frame.classList.remove('rnk-Locked')
  }
}
